import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import AuthService from '../../services/AuthService';
import Loader from '../../components/Loader';
import SubnavBar from '../../components/SubnavBar';
import TitleBar from '../../components/TitleBar';
import List from '../../components/Users/List';
import { UserActions, CompanyActions } from '../../actions';

export class Users extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  static propTypes = {
    auth: PropTypes.instanceOf(AuthService)
  }

  componentWillMount() {
    const { users, companies } = this.props;
    if (!users) {
      this.props.dispatch(UserActions.getUsers());
    }
    if (!companies) {
      this.props.dispatch(CompanyActions.getAllCompanies());
    }
  }

  newUser = () => {
    browserHistory.push('/admin/user');
  }

  render() {
    const { user, users, companies } = this.props;
    const subnavItems = [{ key: 1, label: 'New', onClick: this.newUser }];
    let content;
    if ((!users || users.fetching || !users.list) || (!companies || companies.fetching || !companies.list)) {
      content = <Loader />;
    } else {
      content = <List user={user} users={users.list} companies={companies.list} />
    }

    return (
      <div className="grid">
        <div className="unit whole align-center">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Users" />
          <div className="grid">
            <div className="unit whole">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { user, users, companies } = state;
  return {
    user,
    users,
    companies
  }
}

export default connect(mapStateToProps)(Users);


// WEBPACK FOOTER //
// ./src/containers/Users/index.js